import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withAppContext } from '@ctsu/loader';
import { compose, withHandlers, withState } from 'recompose';
import { savePSR } from 'actions/protocols/psrs';
import { RenderEditable, RenderElement } from 'components/RenderHelpers';
import { bindLogger } from 'helpers/BindLogger';
import { openConfirmation } from 'helpers/Confirmation';
import { openSnackbar } from 'helpers/Notifier';
import { GetFromCtxValue } from 'helpers';
import { httpStatusEnum, TE } from 'appconstants';
import atoms from 'ctsutheme/components/atoms';
import PropTypes from 'prop-types';
import { FasPlus } from 'assets/icons';
import { ProtocolIdSelector, ProtocolNumSelector } from 'selectors';
import _ from 'lodash';
import { ViewPSRDetails } from './ViewPSRDetails';
import { EditPSRDetails } from './EditPSRDetails';

const { Button, Icon } = atoms;

const PSRDetailsInfo = ({
  data,
  setState,
  state,
  add,
  setAdd,
  psrIndex,
  closeEditPSR,
  savePSRInfo,
  context,
  protocolNumber,
  versions,
  editMode,
  editAff,
  setHideAffiliationOnEdit = () => null
}) => {

  useEffect(() => {
    setState(false);
    setAdd(false);
    setHideAffiliationOnEdit(false);
  }, [data, psrIndex, setState, setAdd]);

  // const editFlag = (editMode && data && !['IRBA', 'IRB'].includes(data.code)) || add;

  return (
    <RenderEditable
      state={state}
      editable={editMode}
      setState={closeEditPSR}
      title="PSR Additional Details"
      toolbarItems={(
        <RenderElement access={editMode === true && !state}>
          <Button
            variant="outlined"
            color="primary"
            name="addPsr"
            data-id={`${TE.ID}new_psr${TE.BTN}`}
            onClick={() => {
              setState(true);
              setAdd(true);
              setHideAffiliationOnEdit(true);
            }}
            className="turquoise mr-1"
            title="Add New PSR"
          >
            <Icon className="mr-1">
              <FasPlus />
            </Icon>
            New PSR
          </Button>
        </RenderElement>
      )}
    >
      {!state ? (
        <ViewPSRDetails
          data={data}
          psrIndex={psrIndex}
        />
      ) : (
        <EditPSRDetails
          data={add === true ? {} : data}
          closeEditPSR={closeEditPSR}
          savePSRInfo={savePSRInfo}
          protocolNumber={protocolNumber}
          versions={versions}
          isNewpsr={add === true}
          editMode={editAff}
        />
      )}
    </RenderEditable>
  );
};

const withConnectState = connect(
  state => ({
    protocolId: ProtocolIdSelector(state),
    protocolNumber: ProtocolNumSelector(state)
  }),
  dispatch => bindActionCreators({
    onSavePsr: savePSR
  }, dispatch)
);

export const PSRDetails = compose(
  withConnectState,
  withAppContext,
  withState('state', 'setState', false),
  withState('add', 'setAdd', false),
  withHandlers({
    closeEditPSR: props => event => {
      const { state, setState, setAdd, setHideAffiliationOnEdit } = props;
      setState(!state);
      setAdd(false);
      setHideAffiliationOnEdit(false);
    },
    savePSRInfo: props => postBody => {
      const {
        onSavePsr, context, setState, protocolId, setAdd
      } = props;
      let finalAffils = [];
      const { affiliations } = { ...postBody };
      if (!_.isEmpty(affiliations)) {
        finalAffils = _.map(affiliations, affil => {
          const finalAffil = _.omit(affil, ['index', 'index_parsed']);
          return finalAffil;
        });
      }

      const confirmSavePSR = () => {
        bindLogger(onSavePsr, context)(protocolId, { ...postBody, affiliations: [...finalAffils], prtId: protocolId })
          .subscribe(resp => {
            if (resp.status === httpStatusEnum.SUCCESS) {
              openSnackbar({
                message: GetFromCtxValue(context, 'PROTOCOL_PSR_SUCCESS'),
                variant: 'success',
                name: 'psr'
              });
              setState(false);
              setAdd(false);
            }
          });
      };
      openConfirmation({
        message: GetFromCtxValue(context, 'PROTOCOL_PSR_CONFIRM'),
        onAction: confirmSavePSR,
        name: 'psr_confirm'
      });
    }
  })
)(PSRDetailsInfo);

PSRDetails.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array]),
  psrIndex: PropTypes.number.isRequired
};

PSRDetails.defaultProps = {
  data: null
};
